export default "__VITE_ASSET__DNU5q0dS__"